// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'ios-finger-id';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M2.812 6.75a6.187 6.187 0 0 1 10.125-4.773M14.765 4.5c.28.717.423 1.48.422 2.25v4.5a6.187 6.187 0 0 1-7.312 6.085m-2.812-1.311a6.174 6.174 0 0 1-2.25-4.774V9.563' />
    <path d='M11.812 11.25v-4.5a2.813 2.813 0 0 0-4.5-2.25M6.187 6.75v4.5a2.815 2.815 0 0 0 3.938 2.578M9 7.313v3.375' />
  </g>
);

export const viewBox = '0 0 18 18';
